/** Maps tech stack label to SVG icon filename under /logos/tech/{name}.svg */
export const TECH_STACK_ICONS: Record<string, string> = {
  "Adobe Illustrator": "adobe",
  "Adobe InDesign":  "adobe",
  "Adobe Photoshop": "adobe",
  "Angular":      "angular",
  "Bootstrap":    "bootstrap",
  "Cloudflare Workers": "cloudflare",
  "CSS":          "css",
  "CSS Modules":  "css-modules",
  "D1":           "cloudflare",
  "Digital Ocean": "digital-ocean",
  "Google Maps API": "google",
  "GSAP":         "gsap",
  "Hono":         "hono",
  "Ionic":        "ionic",
  "HTML":         "html",
  "JavaScript":   "javascript",
  "jQuery":       "jquery",
  "Liquid":       "shopify",
  "Microsoft Graph": "microsoft",
  "MySQL":        "mysql",
  "Next.js":      "nextjs",
  "Node.js":      "node",
  "Nuxt.js":      "nuxt",
  "OGL":          "webgl",
  "Payload CMS":  "payload",
  "PHP":          "php",
  "PostCSS":      "postcss",
  "PostgreSQL":   "postgres",
  "R2":           "cloudflare",
  "React":        "react",
  "Shopify":      "shopify",
  "Slim":         "php",
  "Solid.js":     "solid",
  "Supabase":     "supabase",
  "Tailwind CSS": "tailwind",
  "Twig":         "php",
  "TypeScript":   "typescript",
  "Vite":         "vite",
  "Vue":          "vue",
  "WebGL":        "webgl",
  "Webpack":      "webpack",
  "WordPress":    "wordpress",
  "YouTube API":  "google",
}
